import { render, staticRenderFns } from "./serverPoint.vue?vue&type=template&id=6233afb4&"
import script from "./serverPoint.vue?vue&type=script&lang=js&"
export * from "./serverPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports